import React, { useEffect, useState } from "react";
import {
  Button,
  Label,
} from "@fluentui/react-components";
import { ArrowUp20Filled } from "@fluentui/react-icons";
import "../CSS/AgentsComponent.css"
const AgentQueues = (props) => {
  const [agentQueueIds, setAgentQueueIds] = useState([]);
  const [queueList, setQueueList] = useState([]);

  // 🧩 Réorganiser la liste au format affichable
  const formatQueuesList = (agentQueueDetails) => {
    const formattedList = agentQueueDetails.map((queue, index) => ({
      id: queue,
      displayName: props.agent.agentQueueDetails[queue]?.displayName || "Unknown",
      index,
    }));
    setQueueList(formattedList);
  };

  //  Gérer le déplacement vers le haut
  const handleMoveUp = (queue, index) => {
    const updatedQueueIds = [...agentQueueIds];
    const [element] = updatedQueueIds.splice(index, 1);
    updatedQueueIds.splice(index - 1, 0, element);

    setAgentQueueIds(updatedQueueIds);
    props.setAgent({ ...props.agent, agentQueueIds: updatedQueueIds });
  };

  // Charger la liste initiale
  useEffect(() => {
    if (props.agent?.agentQueueIds?.length > 0) {
      setAgentQueueIds(props.agent.agentQueueIds);
      formatQueuesList(props.agent.agentQueueIds);
    }
  }, [props.agent]);

  //  Met à jour la vue dès que la liste change
  useEffect(() => {
    formatQueuesList(agentQueueIds);
  }, [agentQueueIds]);

  return (
    <div
    
    >
      {queueList.map((queue, index) => (
        <div
          key={queue.id}
          className="div-queue-list-style"
         
        >
          <Label weight="semibold">{queue.displayName}</Label>

          <Button
            icon={<ArrowUp20Filled />}
            appearance="subtle"
            aria-label="Move Up"
            disabled={index === 0}
            onClick={() => handleMoveUp(queue.id, index)}
          />
        </div>
      ))}
    </div>
  );
};

export default AgentQueues;
